import { api } from './api';
import type {
  CertificateMetricsResponse,
  AgentMetricsResponse,
  DashboardSummary
} from '@/types/dashboard';

/**
 * Dashboard Service
 * 
 * API calls for dashboard metrics and statistics
 */
export const dashboardService = {
  /**
   * Get certificate metrics
   * @returns Promise<CertificateMetricsResponse>
   */
  getCertificateMetrics: async (): Promise<CertificateMetricsResponse> => {
    const response = await api.get<CertificateMetricsResponse>('/dashboard/certificates');
    return response.data;
  },

  /**
   * Get agent metrics
   * @returns Promise<AgentMetricsResponse>
   */
  getAgentMetrics: async (): Promise<AgentMetricsResponse> => {
    const response = await api.get<AgentMetricsResponse>('/dashboard/agents');
    return response.data;
  },

  /**
   * Get all dashboard metrics at once
   * @returns Promise<DashboardSummary>
   */
  getDashboardSummary: async (): Promise<DashboardSummary> => {
    const [certificateMetrics, agentMetrics] = await Promise.all([
      dashboardService.getCertificateMetrics(),
      dashboardService.getAgentMetrics(),
    ]);

    return {
      certificateMetrics,
      agentMetrics,
    };
  },
};